import CONFIG from '../../globalVariables.js';

class DepartementService {
  static async getAll() {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/departement`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur récupération départements');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur getAll départements:', error);
      throw error;
    }
  }

  static async create(payload) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/departement`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur création département');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur create département:', error);
      throw error;
    }
  }

  static async update(id, payload) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/departement/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur mise à jour département');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur update département:', error);
      throw error;
    }
  }

  static async remove(id) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/departement/${id}`, {
        method: 'DELETE'
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur suppression département');
      }
      return data.data;
    } catch (error) {
      console.error('🚨 Erreur remove département:', error);
      throw error;
    }
  }
}

export default DepartementService;